import Collapse from '@mui/material/Collapse';
import { useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../../../components/common/icon/Icon';

export const Section4 = () => {
  const [isShowCollapse1, setIsShowCollapse1] = useState<boolean>(false);
  const [isShowCollapse2, setIsShowCollapse2] = useState<boolean>(false);

  return (
    <Container>
      <Title>{'자주 묻는 질문'}</Title>

      <QnASection>
        <QnA>
          <QuestionWrap onClick={() => setIsShowCollapse1((prev) => !prev)}>
            <ToggleWrap>
              {isShowCollapse1 ? (
                <Icon name={'ToggleOn'} width={14} height={14} />
              ) : (
                <Icon name={'ToggleOff'} width={14} height={14} />
              )}
            </ToggleWrap>

            <Question>{'등록과 판매는 모두 무료인가요?'}</Question>
          </QuestionWrap>

          <Collapse in={isShowCollapse1} style={{ width: '100%' }}>
            <Answer>
              {'플루바 마켓의 회원 직거래 등록과 판매 활동에 수수료는 없습니다. 등록부터 판매까지 모두 무료입니다.'}
            </Answer>
          </Collapse>
        </QnA>

        <QnA>
          <QuestionWrap onClick={() => setIsShowCollapse2((prev) => !prev)}>
            <ToggleWrap>
              {isShowCollapse2 ? (
                <Icon name={'ToggleOn'} width={14} height={14} />
              ) : (
                <Icon name={'ToggleOff'} width={14} height={14} />
              )}
            </ToggleWrap>

            <Question>{'플루바 매물 같이 워런티나 할부 서비스 적용이 가능할까요?'}</Question>
          </QuestionWrap>

          <Collapse in={isShowCollapse2} style={{ width: '100%' }}>
            <Answer>
              {
                '플루바 마켓은 중계만 도와드리고 있습니다. 회원분들이 좋은 매물을 만날수 있도록 도움을 드리지만 직거래 매물에 대한 거래에 대한 모든 책임은 거래 당사자에게 있음을 명심해주세요.'
              }
            </Answer>
          </Collapse>
        </QnA>
      </QnASection>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  padding: 32px var(--radius-large, 16px);
  padding-bottom: 64px;
  gap: 24px;

  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const Title = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const QnASection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  gap: var(--radius-large, 16px);
`;

const QnA = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;

  gap: var(--radius-medium, 8px);
`;

const QuestionWrap = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;

  gap: var(--radius-small, 4px);

  cursor: pointer;
`;

const ToggleWrap = styled.div`
  width: 20px;
  height: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const Question = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Body/Large/l-light */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 150%; /* 24px */
`;

const Answer = styled.p`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* Body/Large/l-light */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 150%; /* 24px */

  margin-left: 24px;
`;
